 <div id="dialog" >
    <kendo-dialog (close)="onTertiaryButtonClick()" >
        <kendo-dialog-titlebar class="kendo-dialog-titlebar-div">
            <div >
                 {{dialogTitle}}
            </div>
        </kendo-dialog-titlebar>
        <span>Audit Name</span>
        <input id="name" type="text" [(ngModel)]="auditName"/>
        <table>
            <tr>
                 <fieldset ngl-radio-group >
                    <td>
                       <ngl-radio-option label="Run Now"><input ngl type="radio"   (click)="onRunNowClick()"  /></ngl-radio-option><br>
                     </td>
                    <td>
                       <ngl-radio-option label="Run Later"><input ngl type="radio"  [checked]="true"  (click)="onRunLaterClick()" /></ngl-radio-option>
                    </td>
                 </fieldset>
            </tr>
        </table>
        <div >
            <div class="filterGroup" >  Date To Schedule Audit
                <kendo-datepicker [disabled]="isEnabled" [value]="auditProcessedWhen" (valueChange)="onDateChange($event)" [min]="earliestRunDate" [max]="latestRunDate" ></kendo-datepicker> <br> <br>
                Time To Schedule Audit
                <kendo-timepicker [disabled]="isEnabled" class="ExtraSpace" [value]="auditProcessedWhen" (valueChange)="onTimeChange($event)" ></kendo-timepicker>
            </div>
        </div >
        <br>
        <div>
                <div>Notification Template To Apply
                <kendo-dropdownlist  [data]="notificationTemplateList"    valueField="NotificationTemplateID"
                textField="Name" [(ngModel)]="AuditNotificationID"
                [valuePrimitive]="true" [allowCustom]="false" ></kendo-dropdownlist>


                </div>
         </div>
        <div>
            <button class="k-button cvt-primary cvt-kendobutton "  (click)="onPrimaryButtonClick()">{{primaryButtonText}}</button>
           <button class="k-button cvt-primary cvt-kendobutton-cancel"  (click)="onSecondaryButtonClick()" >{{secondaryButtonText}}</button>
         </div>
     </kendo-dialog>
</div>
